var map = {
	"./american_football/unique_tournament.vue": "8724",
	"./badminton/unique_tournament.vue": "75fe",
	"./baseball/unique_tournament.vue": "110d",
	"./basketball/unique_tournament.vue": "9540",
	"./cricket/unique_tournament.vue": "d6b4",
	"./football/unique_tournament.vue": "6eaf",
	"./handball/unique_tournament.vue": "52ee",
	"./ice_hockey/unique_tournament.vue": "ed18",
	"./snooker/unique_tournament.vue": "6d58",
	"./table_tennis/unique_tournament.vue": "68d5",
	"./tennis/unique_tournament.vue": "1e9f",
	"./volleyball/unique_tournament.vue": "891c",
	"./waterpolo/unique_tournament.vue": "312a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a58";